export default __webpack_public_path__ + "static/thumbnail-41e447f85ac43bf9b5a985768a7fd591.png";